import React, { Component } from 'react';
import { Grid, Typography } from '@material-ui/core';
import qmoLogo from '../../scss/img/qmo_logo.png'

type Props = {
    title: string,
    subtitle?: string
}

class LogoAndTitle extends Component<Props> {
    render() {
        return (
            <Grid container alignItems="center">
                <Grid item xs={12} sm={2} style={{ textAlign: 'center' }}>
                    <img alt="" style={{ maxHeight: '100px' }} src={qmoLogo} />
                </Grid>
                <Grid item xs={12} sm={10}>
                    <Typography color="textPrimary" variant="h1">{this.props.title}</Typography>
                    {this.props.subtitle &&
                        <Typography color="textPrimary" variant="h2">&nbsp;{this.props.subtitle}</Typography>
                    }
                </Grid>
            </Grid>
        );
    }
}

export default LogoAndTitle;